import { useSuspenseQuery } from '@tanstack/react-query';
import { signeesQueries } from './signeesQueries';

export const useGetSigneesQuery = (accountId: number) => useSuspenseQuery(signeesQueries.list(accountId));
